import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { invalidateTruckShiftQueries } from 'src/hooks/invalidateTruckShiftQueries';
import { AddRequestBody, EditRequestBody } from 'src/pages/TruckShifts/cellEditor';

export const truckShiftPath = (id: number): string => `/api/v5/truck_shifts/${id}`;
export const truckShiftAssignPath = (id: number): string => `/api/v5/truck_shifts/${id}/assign`;
export const ADD_SHIFT_PATH = '/api/v5/truck_shifts/bulk';

export const useMutationTruckShift = () => {
  const queryClient = useQueryClient();
  const onSuccess = () => { invalidateTruckShiftQueries(queryClient); };

  const edit = useMutation(
    async ({ id, body }: { id: number; body: EditRequestBody }) => { await axios.patch(truckShiftPath(id), body); },
    { onSuccess },
  );
  const remove = useMutation(
    async (id: number) => { await axios.delete(truckShiftPath(id)); },
    { onSuccess },
  );
  const assign = useMutation(
    async ({ id, driverId }: { id: number; driverId: number | null }) => {
      await axios.patch(truckShiftAssignPath(id), { driver_id: driverId });
    },
    { onSuccess },
  );
  const addShift = useMutation(
    async (body: AddRequestBody) => { await axios.post(ADD_SHIFT_PATH, body); },
    { onSuccess },
  );

  return { edit, remove, assign, addShift };
};
